import React, { ComponentProps, ReactNode } from 'react';
import styled from 'styled-components';

import Button from 'components/basic/Button/Button';
import { useIsMobile } from 'hooks/useIsMobile';

const DesktopButtonsWrap = styled.div`
  padding: 16px 24px;
  border-top: 1px solid var(--elevation-light-border);
  display: flex;
  justify-content: space-between;
`;

const MobileWrap = styled.div`
  padding: 0 8px 8px;
`;

interface ModalFooterButtonsProps {
  children?: ReactNode;
  confirmButtonProps?: Partial<ComponentProps<typeof Button>>;
}

const ModalFooterButtons = ({
  children,
  confirmButtonProps,
}: ModalFooterButtonsProps) => {
  const isMobile = useIsMobile();
  const buttons = (
    <>
      {confirmButtonProps && (
        <Button
          widePadding
          onClick={confirmButtonProps.onClick}
          disabled={confirmButtonProps.disabled}
          inline={confirmButtonProps?.inline ?? !isMobile}
          {...confirmButtonProps}
        >
          {confirmButtonProps.children}
        </Button>
      )}
    </>
  );
  return isMobile ? (
    <MobileWrap>
      <div>{buttons}</div>
      {children && (
        <div
          style={{ display: 'flex', justifyContent: 'center', paddingTop: 24 }}
        >
          {children}
        </div>
      )}
    </MobileWrap>
  ) : (
    <DesktopButtonsWrap>
      {children || <div />}
      {buttons}
    </DesktopButtonsWrap>
  );
};

export default ModalFooterButtons;
